import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'no-result',
  styles: [require('./no-result.component.scss')],
  template: require('./no-result.component.html')
})
export class NoResultComponent implements OnInit {
  @Input() public results: any[];
  @Input() public title = 'No Results';

  public ngOnInit() {
    // nothing
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/no-result/no-result.component.ts